import { use } from 'react';

import styled from '@emotion/styled';
import { useTranslations } from 'use-intl';

import { Button } from '@/shared-ui';
import { SurveyThemeContext } from '@/shared-utilities';

interface Props {
  permissionError: string;
  requestPermissions: () => void;
}

const ThemedRoot = styled.div<{ themeStyles: Record<string, string> }>`
  ${(props) => props.themeStyles}
`;

const ProjectUsabilityResponsePermissionDenied = ({
  permissionError,
  requestPermissions,
}: Props) => {
  const { styles } = use(SurveyThemeContext);
  const t = useTranslations('Usability');

  return (
    <ThemedRoot
      themeStyles={styles}
      data-test='usability-permission-denied'
      className='flex min-h-dvh items-center justify-center bg-(image:--brand-bg-image) bg-cover bg-center bg-no-repeat'
    >
      <div className='mx-auto max-w-md px-4 text-center'>
        <div className='mb-4 text-lg font-semibold text-red-600'>
          {t('permissionRequiredTitle')}
        </div>
        <div className='mb-6 text-sm text-gray-600'>{permissionError}</div>
        <Button
          onClick={() => requestPermissions()}
          variant='primary'
          size='md'
          data-test='permission-denied-retry-button'
        >
          {t('tryAgain')}
        </Button>
      </div>
    </ThemedRoot>
  );
};

export default ProjectUsabilityResponsePermissionDenied;
